import { useTranslation } from "react-i18next";
import clsx from "clsx";
import type { HintEntries } from "./types";

export interface HintBoxProps {
  entries: HintEntries;
  isHighlighted: boolean;
}

export const HintBox = ({ entries, isHighlighted }: HintBoxProps) => {
  const { t } = useTranslation();
  return (
    <div className="absolute top-2 right-2 backdrop-blur-sm pointer-events-none z-10">
      <div
        className={clsx(
          "px-2.5 py-1 rounded font-medium text-xs border",
          isHighlighted
            ? "bg-blue-600 text-white border-blue-600 shadow-lg ring-2 ring-blue-400"
            : "bg-white/90 text-gray-700 border-gray-200 shadow-sm",
        )}
      >
        {entries.map((hint) => (
          <div key={hint.key}>{t(hint.key)}</div>
        ))}
      </div>
    </div>
  );
};
